import ArrowRightIcon from "@ant-design/icons/ArrowRightOutlined";
import LockIcon from "@ant-design/icons/LockOutlined";
import { Alert, Button, Form, Input, Spin } from "antd";
import React, { useState } from "react";
import { AppManager } from "../../../../manager";
import Styles from "./Home.scss";

const LoginStep: React.FC<{ onDone: (creds: any) => void }> = ({ onDone }) => {
    const [checkingCreds, setCheckingCreds] = useState(false);
    const [error, setError] = useState("");
    const handleTestLogin = (data: any) => {
        setCheckingCreds(true);
        data.iressURI = data.iressURI || "https://plannercentral.xplan.iress.com.au";
        AppManager.ausplanApps.xplanMigrator.apiTestCredentials(data, (err, resp) => {
            setCheckingCreds(false);
            if (err) {
                AppManager.alert.toastError(`${err}`);
                setError(`${err}`);
            } else if (!resp?.isCredentialsCorrect) {
                AppManager.alert.msgError("Invalid credentials");
                setError("Could not login at this time. Please verify your credentials and try again");
            } else {
                AppManager.alert.msgSuccess("Login success!");
                onDone(data);
            }
        });
    };
    return (
        <div className={Styles.LoginContainer}>
            <div className={Styles.LoginBox}>
                <div className={Styles.LockIndicator}>
                    <div className={Styles.Wrapper}>
                        <LockIcon />
                    </div>
                </div>
                {error && <Alert type="error" message={error} closable onClose={() => setError("")} style={{ marginBottom: 15 }} />}
                <Spin spinning={checkingCreds} tip="Verifying credentials">
                    <Form layout="vertical" onFinish={handleTestLogin}>
                        <Form.Item name="username" label="Iress Username" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name="password" label="Password" rules={[{ required: true }]}>
                            <Input.Password />
                        </Form.Item>
                        <Form.Item name="iressURI" label="Iress URL" help="This is your iress subdomain.">
                            <Input placeholder="Defaults to https://plannercentral.xplan.iress.com.au" />
                        </Form.Item>
                        <div style={{ textAlign: "center", marginTop: 20 }}>
                            <Button size="large" type="primary" htmlType="submit" loading={checkingCreds} disabled={checkingCreds}>
                                Proceed
                                <ArrowRightIcon />
                            </Button>
                        </div>
                    </Form>
                </Spin>
            </div>
        </div>
    );
};

export default LoginStep;
